export default __webpack_public_path__ + "static/media/snowflakeIcon.dea5599d.svg";